export var TAXONOMY_ROOT_PATH = 'root';
export var TAXONOMY_PATH_DELIMITER = '#';